import { Modal } from 'bootstrap';
document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('formPostCheckout');

    if (form) {
        const submitBtn = document.querySelector('.js--checkout_submit');
        const checkboxContainer = document.getElementById('prepay');
        const selectedItemsList = document.querySelector('.js--selected-items-list');
        const personInput = document.querySelector('.js--kit-checkout-person-input');
        let lastSelectedCheckbox = [];


        const wrapersSteps = {
            user: 'kits',
            kits: 'prices',
            prices: 'products',
            products: 'summary',
        };

        updateWrapper();
        renderSelectedItems();

        // Change person

        personInput.addEventListener('change', function (event) {
            const companyField = document.getElementById('companyField');
            const inputCompanyField = companyField.querySelector('input');
            const paymentCashless = document.getElementById('paymentCard');
            const paymentInvoice = document.getElementById('paymentInvoice');

            if (event.target.checked) {
                companyField.style.display = 'none';
                inputCompanyField.classList.add('hidden');
                inputCompanyField.classList.remove('validate');
                paymentCashless.style.display = 'flex';
                setTimeout( () => {
                    window.customForms[form.getAttribute('id')].mutators.registerField();
                }, 150);
            } else {
                paymentCashless.style.display = 'none';
                companyField.style.display = 'block';
                inputCompanyField.classList.remove('hidden');
                inputCompanyField.classList.add('validate');
                if (getComputedStyle(paymentCashless).display === 'none') {
                    paymentInvoice.click();
                    inputCompanyField.value = '';
                }
                setTimeout( () => {
                    window.customForms[form.getAttribute('id')].mutators.registerField();
                }, 150);
            }

            updateState();
            updateSummary();
        });



        // Change kit

        document.body.addEventListener('htmx:afterSettle', function (evt) {
            if (evt.detail.target.id === 'prepay') {
                const radioButton = document.querySelector('input[type="radio"][data-value="month_12"]');
                if (radioButton) {
                    radioButton.click();
                    highlightWrapper('prices');
                    cleanSummaryProducts();
                    updateState();
                    updateSummary();
                }
            }
            if (evt.detail.target.id === 'additional') {
                cleanSummaryProducts();
                render();
                updateState();
                updateSummary();
                const newCheckboxes = checkboxContainer.querySelectorAll('.js--kit-checkout-product-input');
                newCheckboxes.forEach((checkbox) => {
                    if (lastSelectedCheckbox.includes(checkbox.value)) {
                        checkbox.click();
                    }
                });
                lastSelectedCheckbox = [];
            }
        });

        // Change price (period)

        document.addEventListener('change', (event) => {
            if (event.target.closest('.js--kit-checkout-price-input')) {
                highlightWrapper('products');
                cleanSummaryProducts();
                render();
                updateState();
                updateSummary();
            }
        });


        // Change payment

        document.addEventListener('change', (event) => {
            if (event.target.closest('.js--kit-checkout-payment-input')) {
                updateState();
                render();
            }
        });

        function highlightWrapper(wrapper, scrolling = true) {
            const wrappers = document.querySelectorAll('.js--wrapper');
            let wrapperElement = document.querySelector(`.js--wrapper[data-wrapper="${wrapper}"]`);

            if (wrapper === 'products' && !wrapperElement) {
                const nextWrapper = getNextWrapper(wrapper);
                wrapperElement = document.querySelector(`.js--wrapper[data-wrapper="${nextWrapper}"]`);
            }

            if (wrapperElement) {
                wrappers.forEach(wrap => wrap.classList.remove('focused'));

                if (scrolling) {
                    setTimeout(() => {
                        const isSticky = window.getComputedStyle(wrapperElement).position === 'sticky';
                        const stickyHeight = isSticky ? wrapperElement.offsetHeight : 0;
                        const elementPosition = wrapperElement.getBoundingClientRect().top + window.pageYOffset;
                        const offsetPosition = elementPosition - stickyHeight - 200;
                        window.scrollTo({
                            top: offsetPosition,
                            behavior: 'smooth'
                        });
                    }, 300);
                }

                wrapperElement.classList.add('focused');
            }
        }

        function getNextWrapper(currentWrapper) {
            if (wrapersSteps.hasOwnProperty(currentWrapper)) {
                return wrapersSteps[currentWrapper];
            }

            return false;
        }

        function state() {
            return new URLSearchParams(window.location.search);
        }

        function updateWrapper() {
            const stateData = state();
            const kit = stateData.get('post_id');
            const period = stateData.get('period');
            const product = stateData.get('product');
            const productWrapper = document.querySelector('.js--wrapper[data-wrapper="products"]');
            if (kit && period && product) {
                highlightWrapper('summary', false);
            }
            if (kit && period) {
                highlightWrapper('summary', false);
            }
            if (kit && !period) {
                highlightWrapper('prices', false);
            }
            if (kit && period && productWrapper && !product) {
                highlightWrapper('products', false);
            }
            if (!kit) {
                highlightWrapper('kits', false);
            }
        }

        function updateState() {
            const stateData = state();


            const checkboxesAndRadios = form.querySelectorAll('input[type="checkbox"], input[type="radio"]');
            let selectedCheckbox = [];

            checkboxesAndRadios.forEach(element => {
                if (element.type === 'radio' && element.checked) {
                    if (element.dataset.name === 'period') {
                        stateData.set(element.dataset.name, element.dataset.value);
                    } else if (element.dataset.name === 'payment') {
                        stateData.set(element.dataset.name, element.dataset.value);
                    }
                }

                if (element.type === 'checkbox') {
                    if (element.name === 'product' && element.checked) {
                        selectedCheckbox.push(element.value);
                        stateData.set(element.dataset.name, selectedCheckbox.join(','));
                    } else if (element.dataset.name === 'person') {
                        if (element.checked) {
                            stateData.set(element.dataset.name, element.value);
                        } else {
                            stateData.set(element.dataset.name, 'ur');
                        }
                    }
                }

            });
            window.history.replaceState({}, '', `${window.location.pathname}?${stateData}`);
        }

        function render() {
            const stateData = state();
            const payment = stateData.get('payment');
            const period = stateData.get('period');
            if (!period) {
                const radioButton = document.querySelector('input[type="radio"][data-value="month_12"]');
                const radioButtons = document.querySelectorAll('input[type="radio"][data-value="month_12"]');
                if (radioButton) {
                    radioButton.click();
                }
            }

            if (payment === 'cash') {
                submitBtn.querySelector('.js--button_text').textContent = submitBtn.getAttribute('data-cashless-text');
            } else {
                submitBtn.querySelector('.js--button_text').textContent = submitBtn.getAttribute('data-card-text');
            }


        }

        function updateSummary() {
            let stateData = state();
            let postData = {};

            if (stateData.has('post_id')) {
                postData.post_id = stateData.get('post_id');
            }

            if (stateData.has('period')) {
                postData.period = stateData.get('period');
            }


            fetch('/checkout-ajax/summary', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(postData)
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then(data => {
                    document.querySelector('.js--price_set').textContent = `${data.price}.00`;
                    document.querySelector('.js--price_discount').textContent = `${data.discount}.00`;
                    document.querySelector('.js--price_summary').textContent = `${data.summary}.00`;
                })
                .catch(error => {
                    console.error('There was a problem with the fetch operation:', error);
                });
        }

        function cleanSummaryProducts() {
            if (selectedItemsList) {
                selectedItemsList.innerHTML = '';
            }
        }

        function renderSelectedItems() {
            cleanSummaryProducts();
            render();
            updateState();
        }

        const stickyWrapper = document.querySelector('.checkout__summary.js--wrapper');
        const accordionButton = document.querySelector('.js--accordion_product_button');
        const accordionCollapse = document.querySelector('.js--accordion_product_collapse');
        const sentinel = document.createElement('div');

        if (stickyWrapper) {
            sentinel.style.position = 'absolute';
            sentinel.style.top = `${stickyWrapper.offsetTop - 1}px`;
            document.body.prepend(sentinel);
        }

        function collapseAccordion() {
            if (accordionCollapse && accordionCollapse.classList.contains('show')) {
                accordionButton.click();
            }
        }

        const collapseObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) {
                        collapseAccordion();
                        collapseObserver.disconnect();
                    }
                });
            },
            {
                rootMargin: '0px 0px 0px 0px',
                threshold: 0,
            }
        );

        collapseObserver.observe(sentinel);
    }
});
